<img
  [src]="absolutePath"
  [title]="title"
  [alt]="alt"
  [class]="className"
  [ngStyle]="style"
  *ngIf="absolutePath"
/>
